module.exports = __webpack_public_path__ + "static/media/add-day.9a81c9f1.png";